const statusClass: Record<string, string> = {
  Completed: "bg-green-100 text-green-700",
  Confirmed: "bg-green-100 text-green-700",
  "New Lead": "bg-blue-100 text-blue-700",
  Scheduled: "bg-blue-100 text-blue-700",
  Updated: "bg-blue-100 text-blue-700",
  Missed: "bg-orange-100 text-orange-700",
  Pending: "bg-orange-100 text-orange-700",
};

export function StatusPill({ status }: { status: string }) {
  return (
    <span
      className={`inline-flex min-w-[72px] items-center justify-center rounded-full px-3 py-1.5 text-xs font-semibold ${
        statusClass[status] || "bg-gray-100 text-gray-700"
      }`}
    >
      {status}
    </span>
  );
}
